import { render, staticRenderFns } from "./ValueVertical.vue?vue&type=template&id=7451b171&"
import script from "./ValueVertical.vue?vue&type=script&lang=js&"
export * from "./ValueVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ValueVertical.vue"
export default component.exports